export const userRoleTypes = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  SUPER_USER: 'SUPER_USER',
  USER: 'USER',
  VIEWER: 'VIEWER'
}
